import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CurrentUser } from '@shared/interfaces';
import { UserRoleEnum } from '@shared/enums';
import { UserApi } from '@core/api';
import { UserPreferencesService } from './user-preferences.service';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
    currentUser$: Subject<CurrentUser> = new Subject<CurrentUser>();

    isUnauthorized$: Subject<boolean> = new Subject<boolean>();

    private currentUser: CurrentUser = {
        id: '',
        firstName: '',
        lastName: '',
        shortName: '',
        email: '',
        laboratoryId: null,
        laboratoryName: '',
        role: UserRoleEnum.UNKNOWN,
        hasCentralShippingAdminRole: false,
    };

    constructor(private userApi: UserApi, private userPreferencesService: UserPreferencesService) {}

    async initializeCurrentUser(): Promise<CurrentUser | null> {
        if (this.currentUser.id) {
            return this.currentUser;
        }

        const response = await this.userApi.getCurrentUserDetails();
        if (response) {
            this.setCurrentUser(response.user);
            this.userPreferencesService.initializeUserPreferences(response.preferences);
            return this.currentUser;
        }
        return null;
    }

    getCurrentUser(): CurrentUser {
        return this.currentUser;
    }

    getCurrentUserRole(): UserRoleEnum {
        return this.currentUser.role;
    }

    setCurrentUser(user: CurrentUser): void {
        this.currentUser$.next(user);
        this.currentUser = user;
    }

    triggerUnauthorizedError(value: boolean): void {
        this.isUnauthorized$.next(value);
    }
}
